import { render } from "./Button2.vue?vue&type=template&id=331d2d3a"
import script from "./Button2.vue?vue&type=script&lang=js"
export * from "./Button2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__